package com.example.mystybag.core.expected

/**
 * Result of a successful Google Sign-In flow returned by [signInWithGoogle].
 *
 * `email` and `idToken` are always populated; the remaining profile fields are
 * optional because Google may not always provide them (e.g. user can hide their
 * profile photo, or the platform SDK can omit names).
 */
data class GoogleSignInResult(
    val email: String,
    val idToken: String,
    val firstName: String? = null,
    val lastName: String? = null,
    val photoUrl: String? = null,
)
